/**
 * Created by zad on 17/10/25.
 */
import { User } from '../constants/actionTypes';
import createAction from '../utils/createAction';

// eslint-disable-next-line import/prefer-default-export
export const getUser = createAction(User.GET_USER);

export const getUserOtpChannel = createAction(User.GET_USER_OTP_CHANNEL);

export const changeEditorType = createAction(User.CHANGE_EDITOR_TYPE, 'editorType');

export const setUser = createAction(User.SET_USER, 'data');

export const switchSyncScroll = createAction(User.SWITCH_SYNC_SCROLL, 'on');



// WEBPACK FOOTER //
// ./src/actions/UserAction.js